// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
  background: white;
  border-radius: 8px;
  padding: 32px 24px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.3s ease;
}
.error-modal .error-icon {
  height: 80px;
  width: 80px;
  margin-bottom: 15px;
}
.error-modal h2 {
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 22px;
}
.error-modal p {
  font-size: 15px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  text-wrap: balance;
  color: #393939;
  margin-bottom: 37px;
}

.button-wrap {
  text-align: center;
  cursor: pointer;
  padding-top: 10px;
}
.button-wrap .btn {
  height: 46px;
  background: var(--ion-color-tertiary);
  border-radius: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  box-shadow: 2px 2px 0px #000000;
  border: 1px solid var(--ion-color-secondary);
  padding: 12px 40px;
  gap: 6px;
}
.button-wrap .btn span {
  font-family: AppFont;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  color: var(--ion-color-secondary);
}
.button-wrap .btn ion-spinner {
  color: var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/panic-mode-modal/panic-mode-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;AACF;AAEC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EAEA,kBAAA;EACA,cAAA;EACA,mBAAA;AAFF;;AAMA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;AAHD;AAKC;EACC,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;EACA,4CAAA;EACA,kBAAA;EACA,QAAA;AAHF;AAIE;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;AAFH;AAKE;EACC,iCAAA;AAHH","sourcesContent":[".error-modal {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 32px 24px;\n\twidth: 100%;\n\ttext-align: center;\n\tanimation: slideUp 0.3s ease;\n\n\t.error-icon {\n\t\theight: 80px;\n\t\twidth: 80px;\n\t\tmargin-bottom: 15px;\n\t}\n\n\th2 {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 18px;\n\t\tline-height: 130%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 22px;\n\t}\n\n\tp {\n\t\tfont-size: 15px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: capitalize;\n\n\t\ttext-wrap: balance;\n\t\tcolor: #393939;\n\t\tmargin-bottom: 37px;\n\t}\n}\n\n.button-wrap {\n\ttext-align: center;\n\tcursor: pointer;\n\tpadding-top: 10px;\n\n\t.btn {\n\t\theight: 46px;\n\t\tbackground: var(--ion-color-tertiary);\n\t\tborder-radius: 1px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin: 0 auto;\n\t\tbox-shadow: 2px 2px 0px #000000;\n\t\tborder: 1px solid var(--ion-color-secondary);\n\t\tpadding: 12px 40px;\n\t\tgap: 6px;\n\t\tspan {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 135%;\n\t\t\tletter-spacing: 0.01em;\n\t\t\ttext-align: center;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\n\t\tion-spinner {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
